const ParticipantsIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_participants)">
            <path
                d="M14.1665 16.417C17.3732 16.6878 19.5832 17.2587 19.5832 17.917C19.5832 18.8337 15.2932 19.5837 9.99984 19.5837C4.7065 19.5837 0.416504 18.8337 0.416504 17.917C0.416504 17.2587 2.61234 16.6895 5.79817 16.417"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.2085 3.95801C15.2085 4.45529 15.406 4.9322 15.7577 5.28383C16.1093 5.63546 16.5862 5.83301 17.0835 5.83301C17.5808 5.83301 18.0577 5.63546 18.4093 5.28383C18.761 4.9322 18.9585 4.45529 18.9585 3.95801C18.9585 3.46073 18.761 2.98381 18.4093 2.63218C18.0577 2.28055 17.5808 2.08301 17.0835 2.08301C16.5862 2.08301 16.1093 2.28055 15.7577 2.63218C15.406 2.98381 15.2085 3.46073 15.2085 3.95801Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.0835 6.66699C16.4205 6.66699 15.7846 6.93038 15.3157 7.39922C14.8469 7.86807 14.5835 8.50395 14.5835 9.16699V11.2503H15.8335L16.2502 15.0003H17.9168L18.3335 11.2503H19.5835V9.16699C19.5835 8.50395 19.3201 7.86807 18.8513 7.39922C18.3824 6.93038 17.7465 6.66699 17.0835 6.66699Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.0415 3.95801C1.0415 4.20424 1.09 4.44805 1.18423 4.67554C1.27846 4.90302 1.41657 5.10972 1.59068 5.28383C1.76479 5.45794 1.97149 5.59605 2.19897 5.69028C2.42646 5.78451 2.67028 5.83301 2.9165 5.83301C3.16273 5.83301 3.40655 5.78451 3.63404 5.69028C3.86152 5.59605 4.06822 5.45794 4.24233 5.28383C4.41644 5.10972 4.55455 4.90302 4.64878 4.67554C4.74301 4.44805 4.7915 4.20424 4.7915 3.95801C4.7915 3.71178 4.74301 3.46796 4.64878 3.24048C4.55455 3.01299 4.41644 2.80629 4.24233 2.63218C4.06822 2.45807 3.86152 2.31996 3.63404 2.22573C3.40655 2.13151 3.16273 2.08301 2.9165 2.08301C2.67028 2.08301 2.42646 2.13151 2.19897 2.22573C1.97149 2.31996 1.76479 2.45807 1.59068 2.63218C1.41657 2.80629 1.27846 3.01299 1.18423 3.24048C1.09 3.46796 1.0415 3.71178 1.0415 3.95801Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.9165 6.66699C2.25346 6.66699 1.61758 6.93038 1.14874 7.39922C0.679896 7.86807 0.416504 8.50395 0.416504 9.16699V11.2503H1.6665L2.08317 15.0003H3.74984L4.1665 11.2503H5.4165V9.16699C5.4165 8.50395 5.15311 7.86807 4.68427 7.39922C4.21543 6.93038 3.57955 6.66699 2.9165 6.66699Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.7085 2.70866C7.7085 3.31645 7.94994 3.89934 8.37971 4.32911C8.80948 4.75888 9.39238 5.00033 10.0002 5.00033C10.608 5.00033 11.1908 4.75888 11.6206 4.32911C12.0504 3.89934 12.2918 3.31645 12.2918 2.70866C12.2918 2.10087 12.0504 1.51798 11.6206 1.08821C11.1908 0.658435 10.608 0.416992 10.0002 0.416992C9.39238 0.416992 8.80948 0.658435 8.37971 1.08821C7.94994 1.51798 7.7085 2.10087 7.7085 2.70866Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.9168 8.74967C12.9168 7.97613 12.6095 7.23426 12.0626 6.68728C11.5156 6.1403 10.7737 5.83301 10.0002 5.83301C9.22661 5.83301 8.48475 6.1403 7.93777 6.68728C7.39079 7.23426 7.0835 7.97613 7.0835 8.74967V11.2497H8.40266L8.75016 15.4163H11.2502L11.5977 11.2497H12.9168V8.74967Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_participants">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default ParticipantsIcon;

